import $ from 'jquery'
import Flickity from 'flickity'

import jqueryBridget from 'jquery-bridget'

$.bridget( 'flickity', Flickity)

export default {

  enable () {
    $('.partenaire-slider').flickity({
     
      bgLazyLoad: true,
      autoPlay: 1000,
      wrapAround: true,
      pauseAutoPlayOnHover: false
      // at end of cells, wraps-around to first for infinite scrolling
      
    })
  

  }
}



// WEBPACK FOOTER //
// ./src/js/elements/partenaire-slider.js